<script>
    import Button from "./Button.svelte";

    /**
     * An array of strings, where each string is the text of the button.
     */
    export let sections;
    export let activeSection = 0;
</script>

<div class="btn-container">
    {#each sections as section, idx}
        <Button
            on:click={() => activeSection = idx}
            isActive={activeSection === idx}
            extraClasses={["panel-btn"]}
        >{section}</Button>
    {/each}
</div>

<style>
    .btn-container {
        display: flex;
        justify-content: flex-start;
        margin-top: 1em;
        margin-bottom: 20px;
    }

    .btn-container :global(button.panel-btn) {
        background-color: #e1e1e1;
        color: #586d7b;
        padding-left: 1em;
        padding-right: 1em;
        padding-bottom: 0.5em;
        padding-top: .2em;
        padding-bottom: .2em;
        margin: 0px;
        margin-bottom: 1em;
        border: 1px solid #586d7b;
        width: 33%;
        min-height: 40px;
    }

    .btn-container :global(button.panel-btn.active) {
        background-color: #5FA061;
        color: white;
    }

    .btn-container :global(button.panel-btn.active:focus), .btn-container :global(button.panel-btn.active:hover) {
        background-color: #006838 !important;
    }

    .btn-container :global(button.panel-btn:focus), .btn-container :global(button.panel-btn:hover) {
        background-color: #bac5ce !important;
    }
</style>